import { render } from "./UnlockView.vue?vue&type=template&id=a56573d2"
import script from "./UnlockView.vue?vue&type=script&lang=js"
export * from "./UnlockView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__